import {
    BankingApi,
    CoreFetch,
    IntegrationApi,
    ProviderIntegrationWebhooksFromJSON,
    ProviderPlaidItemInfo,
    RoleApi,
    UserApi
} from '@enter/core';
import _ from 'lodash';
import { equalsFilter } from './util';

export class SettingsService {
    public async listProviderUsers() {
        return CoreFetch<UserApi>(UserApi).listProviderUsers({
            filterActive: _.first(equalsFilter('1')),
        });
    }

    public async listProviderIntegrationApis() {
        return CoreFetch<IntegrationApi>(IntegrationApi).listProviderApiIntegrations({});
    }

    public async listProviderIntegrationHl7s() {
        return CoreFetch<IntegrationApi>(IntegrationApi).listProviderHl7Integrations({});
    }

    public async listProviderIntegrationSftps() {
        return CoreFetch<IntegrationApi>(IntegrationApi).listProviderApplicationSftp({});
    }

    public async getProviderIntegrationWebhooksUrl() {
        return CoreFetch<IntegrationApi>(IntegrationApi).postProviderIntegrationWebhooks().catch(e => {
            if(e.status === 500) {
                return ProviderIntegrationWebhooksFromJSON("{}");
            } else {
                throw e;
            }
        });
    }

    public async listProviderRoles() {
        return CoreFetch<RoleApi>(RoleApi).listProviderRoles();
    }

    public async listProviderBankingAccounts() {
        // @ts-expect-error - banking is deprecated
        return CoreFetch<BankingApi>(BankingApi).listProviderBankingAccounts({});
    }

    public async listPlaidItems(): Promise<ProviderPlaidItemInfo[]> {
        return CoreFetch<BankingApi>(BankingApi).listPlaidItems();
    }

    public async getPlaidLinkToken() {
        return CoreFetch<BankingApi>(BankingApi).postCreateLinkToken();
    }

    public async connectPlaidAccount(publicToken: string, institutionId: string) {
        return CoreFetch<BankingApi>(BankingApi).postConnectPlaidToBank({
            plaidConnectToBankPayload: {
                publicToken,
                institutionId,
            },
        });
    }

    public async deletePlaidItem(id: string) {
        return CoreFetch<BankingApi>(BankingApi).deletePlaidItem({ id });
    }
}
